<template>
    <div class="customer_service">
        <van-nav-bar title="联系客服" left-arrow @click-left="closePage" />
        <img class="banner" src="../../assets/customer/banner.png" alt="">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :disabled="true">
            <div class="main">
                <div class="title">
                    <div class="left">
                        <div>Hi~</div>
                        <div>有什么可以帮您！</div>
                    </div>
                    <img class="service" src="../../assets/customer/service.png" alt="">
                </div>
                <div class="content">
                    <div class="con1">
                        <img class="wx" src="../../assets/customer/wx.png" alt="">
                        <div class="right">
                            <div class="r1">微信人工客服</div>
                            <div class="r2">使用中如需帮助，<a href="https://work.weixin.qq.com/kfid/kfc6767dfd74b3a5956">点我咨询</a></div>
                        </div>
                    </div>
                    <div class="con2">
                        <div class="qrcode">
                            <img src="../../assets/customer/code.jpg" alt="">
                        </div>
                        <div class="word1">扫描上方二维码 关注官方公众号</div>
                        <div class="word2"> 微信公众号&nbsp;&nbsp;添加搜索：千年游</div>
                    </div>
                </div>
                <div class="explain">
                    <div class="tit">服务说明</div>
                    <div class="ex_item">
                        1.亲爱的玩家您好平台客服工作时间7*24小时
                    </div>
                    <div class="ex_item">
                        2.如您有任何游戏平台相关问题可随时咨询我们
                    </div>
                    <div class="ex_item">
                        3.游戏内问题您可咨询游戏内官方客服
                    </div>
                    <div class="ex_item">
                        4.官方网址: www.qn3975.com<br>
                    </div>
                    <div class="ex_item">
                        感谢您对千年游戏盒子的支持和厚爱，祝您游戏愉快。
                    </div>
                </div>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {
            
        },
        methods: {
            
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.banner {
    position: fixed;
    top: 2.5rem;
    left: 0;
    z-index: -1;
    width: 100%;
    height: auto;
}
.main {
    margin-top: 2.5rem;
    padding: 1rem .75rem 1rem;
    .title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1.9rem;
        .left {
            font-size: .9rem;
            font-weight: 700;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            color: #000;
        }
        .service {
            width: 3.05rem;
            height: 3.25rem;
            margin-left: 2.35rem;
           
        }
    }
    .content {
        margin: 0 auto 1.3rem;
        width: 17.25rem;
        height: 15.9rem;
        padding: 1.35rem .9rem 1.7rem;
        background-image: url(../../assets/customer/bg.png);
        background-position: 0 0;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .con1 {
            display: flex;
            align-items: center;
            padding-bottom: 1rem;
            border-bottom: 1px dashed #9e9e9e;
            .wx {
                width: 2.35rem;
                height: 2.35rem;
                margin-right: .9rem;
            }
            .right {
                font-size: .7rem;
                line-height: 1.8;
                .r1 {
                    color: #000;
                    font-weight: 700;
                }
                .r2 {
                    color: #000;
                    font-size: .7rem;
                    span {
                        color: #670000;
                    }
                }
            }
        }
        .con2 {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 0.8rem;
            .qrcode {
                width: 6rem;
                height: 6rem;
                border: 1px solid #670000;
                margin-bottom: 0.8rem;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .word1 {
                font-size: .7rem;
                color: #670000;
                font-weight: 700;
                margin-bottom: .3rem;
            }
            .word2 {
                font-size: .6rem;
                color: #9e9e9e;
            }
        }
    }
    .explain {
        margin: 0 auto;
        width: 17.25rem;
        border-radius: .7rem;
        padding: .8rem .85rem 1rem;
        background-color: #fff;
        -webkit-user-select: text;
        .tit {
            font-size: .7rem;
            font-weight: 700;
            color: #000;
            margin-bottom: .8rem;
        }
        .ex_item {
            color: #9e9e9e;
            font-size: .6rem;
            margin-bottom: 0.3rem;
        }
    }
}
</style>